import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Actions, AuthContextConsumer, Callback } from '@grandvisionhq/auth';
import { connect } from '@grandvisionhq/state';
import PageWithMenu from '../PageWithMenu/PageWithMenu.js';
import { OnlyOnClient } from './OnlyOnClient.js';
import PageNotFound from './PageNotFound/PageNotFound.js';

class MyAccountRoot extends React.Component {
    render() {
        const currentRoute = this.state.currentRoute;
        if (currentRoute === 'callback' || currentRoute === 'logged-out') {
            return /*#__PURE__*/ React.createElement(Callback, {
                type: currentRoute,
                parseHash: this.props.parseHash,
                loggedOut: this.props.loggedOut
            });
        }
        /**
     * Next.js seems to render a higher level route before it renders a lowe level route. E.g. when
     * rendering /pages/my-account/prescriptions.tsx, it renders pages/my-account/[...rest].tsx first.
     * Issue: https://github.com/vercel/next.js/issues/43209
     *
     * To minimize layout shift, we render a loading screen.
     */ return /*#__PURE__*/ React.createElement("div", {
            className: "myaccount-root myaccount-root--center"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "site-container"
        }, /*#__PURE__*/ React.createElement(PageWithMenu, null, /*#__PURE__*/ React.createElement(PageNotFound, null))));
    }
    constructor(...args){
        super(...args);
        this.state = {
            currentRoute: this.props.initialRoute.replace(/\/$/, '')
        };
    }
}
const mapDispatchToProps = {
    parseHash: Actions.LoginActions.parseHash,
    loggedOut: Actions.LogoutActions.loggedOut
};
const MyAccountRootConnected = connect(null, mapDispatchToProps)(MyAccountRoot);
const MyAccountRootConnectedClientOnly = (props)=>{
    return /*#__PURE__*/ React.createElement(OnlyOnClient, null, /*#__PURE__*/ React.createElement(MyAccountRootConnected, swcHelpers.extends({}, props)));
};
class MyAccountRootConnectedClientOnlyWithContext extends React.PureComponent {
    render() {
        return /*#__PURE__*/ React.createElement(AuthContextConsumer, null, /*#__PURE__*/ React.createElement(MyAccountRootConnectedClientOnly, swcHelpers.extends({}, this.props)));
    }
}

export { MyAccountRoot, MyAccountRootConnected, MyAccountRootConnectedClientOnly, MyAccountRootConnectedClientOnlyWithContext as default, mapDispatchToProps };
//# sourceMappingURL=MyAccountRoot.js.map
